import { Avatar, Grid, IconButton, Typography } from "@mui/material";
import theme from "../../../theme";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Link } from "react-router-dom";
import Loader from "../../ui/Loader";

interface PropTypes {
  Icon: any;
  Label: string;
  LabelValue: string;
  to: string;
  isLoading?: any;
  canRedirect?: boolean;
}

const PromotionDetails = (props: PropTypes) => {
  const { Icon, Label, LabelValue, to, isLoading, canRedirect } = props;
  return (
    <Grid
      style={{
        width: "100%",
        borderRadius: "16px",
        display: "flex",
        alignItems: "center",
      }}
      sx={{ background: theme.color?.background }}
    >
      <Grid
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          justifyContent: "space-evenly",
        }}
      >
        <Avatar sx={{ background: "#FFE4E1", height: "71px", width: "71px" }}>
          <Icon sx={{ color: "#E57467" }} />
        </Avatar>
        <Grid>
          {isLoading ? (
            <Loader />
          ) : (
            <Typography
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                fontSize: "32px",
                fontWeight: theme.font?.fontWeight.thick,
                color: "#717171",
              }}
            >
              {LabelValue ? LabelValue : "0"}
            </Typography>
          )}
          <Typography
            sx={{
              fontFamily: theme.font?.fontFamily.primary,
              fontSize: "16px",
              fontWeight: theme.font?.fontWeight.thick,
              color: "#AEAEAE",
            }}
          >
            {Label}
          </Typography>
        </Grid>
        {canRedirect && (
          <IconButton component={Link} to={`/${to}`}>
            <ArrowForwardIosIcon sx={{ color: "#F1B53D" }} />
          </IconButton>
        )}
      </Grid>
    </Grid>
  );
};

export default PromotionDetails;
